<template>
  <card-component title="Login" icon="lock" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submit" method="POST">

      <b-field>
        <b-input icon="email" type="email" v-model="form.email" placeholder="E-mail" name="email" required />
      </b-field>

      <b-field label="Contraseña">
        <b-input v-model="form.password" type="password" name="password" required/>
      </b-field>

      <hr>

      <b-field grouped>
        <div class="control">
          <button type="submit" class="button is-black" :class="{'is-loading':isLoading}">
            Ingresar
          </button>
        </div>
      </b-field>
    </form>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'

export default {
  name: 'Login',
  components: { CardComponent },
  data () {
    return {
      isLoading: false,
      form: {
        email: null,
        password: null
      }
    }
  },
  created () {
    this.$store.commit('removeToken')
  },
  methods: {
    submit () {
      this.isLoading = true
      const self = this
      setTimeout(() => {
        this.isLoading = false
        this.$store.dispatch('obtainToken',
          {
            username: this.form.email,
            password: this.form.password
          }
        ).then(result => {
          this.$router.push('/dashboard')
        }).catch((error) => {
          self.$buefy.toast.open({
            message: error.response.data.detail,
            type: 'is-danger'
          })
        })
      }, 750)
    }
  }
}
</script>
